
import CardWrapper from "../../../../components/wrapper/card/CardWrapper.tsx";
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts";
import { ELng } from "../../../../../../../language/main/LanguageKeysEnums.ts";
import { useTranslation } from "react-i18next";
import { webVideos } from "../../../../../../../Media.ts";
import CommonReactGUIElementsFactory from "../../../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory.tsx";
import VideoSlideGallery from "../../../../../../../commonreact/main/components/gallerys/video/VideoSlideGallery.tsx";
import { IModalVideoControllerReturn } from "../../../../../../../commonreact/main/components/modals/modalvideo/ModalVideoController.ts";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  ef: CommonReactGUIElementsFactory;
  mvc: IModalVideoControllerReturn;
}

export const WebsiteVideoGalleryCard: React.FC<IProps> = (props): JSX.Element => {

  const { t } = useTranslation();

  const height = props.dsc.screenHeight();
  const nt = "/2: ";
  const tn = " Tutorial";
  const vr = 256 / 144;
  const videoItems = [
    { header: tn + " 1" + nt + t(ELng.video_web_harmonical_systems.valueOf()), img: webVideos.web_systems_tn, src: webVideos.web_systems, videoSizeRatio:vr },
    { header: tn + " 2" + nt + t(ELng.video_web_progressions.valueOf()), img: webVideos.web_progressions_tn, src: webVideos.web_progressions, videoSizeRatio:vr },
    { header: t(ELng.video_web_jazz_iivi.valueOf()), img: webVideos.web_jazz_iivi_tn, src: webVideos.web_jazz_iivi, videoSizeRatio:vr }
  ];


  return (
    <CardWrapper
      dsc={props.dsc}
      header={<h3>
        {t(ELng.website_videogallery_header.valueOf())}

        </h3>}
    >
      <div className="flex flex-col">
        <div className="mt-5">
          <VideoSlideGallery dsc={props.dsc} height={height} videos={videoItems} mvc={props.mvc} />
        </div>
        <div className="mt-5">
        </div>
      </div>
    </CardWrapper>
  )
}